import { SideNavInterface } from '../../interfaces/side-nav.type';
export const ROUTES: SideNavInterface[] = [
    {
        path: '#',
        father: 'accounting-software-integration',
        title: 'Contabilidad Fintech',
        admin: false,
        iconType: 'custom',
        iconTheme: '',
        icon: 'pin-contable-icon',
        submenu: [
            {
                path: '/reports/management/panel-resumen',
                father: null,
                title: 'Panel de Resumen',
                admin: false,
                iconType: '',
                icon: '',
                iconTheme: '',
                submenu: []
            },
            {
                path: '/reports/management/results',
                father: null,
                title: 'Análisis Comercial',
                admin: false,
                iconType: '',
                iconTheme: '',
                icon: '',
                submenu: []
            },
            {
                path: '/accounting-software-integration/balance',
                father: null,
                title: 'Informes Financieros',
                admin: false,
                iconType: '',
                icon: '',
                iconTheme: '',
                submenu: []
            },
            {
                path: '/accounting-software-integration/cash-flow',
                father: null,
                title: 'Flujo de Caja',
                admin: false,
                iconType: '',
                icon: '',
                iconTheme: '',
                submenu: []
            },
            {
                path: '/reports/tributary',
                father: null,
                title: 'Información Tributaria',
                admin: false,
                iconType: '',
                icon: '',
                iconTheme: '',
                submenu: []
            },
            {
                path: '/reports/management/comparacion-periodos',
                father: null,
                title: 'Comparación de Períodos',
                admin: false,
                iconType: '',
                iconTheme: '',
                icon: '',
                submenu: []
            },
            {
                path: '/consistency-reports/reports',
                father: null,
                title: 'Verificación Contable',
                admin: false,
                iconType: '',
                icon: '',
                iconTheme: '',
                submenu: []
            },
            {
                path: '/accounting-software-integration/ratio',
                father: null,
                title: 'Indicadores',
                admin: false,
                iconType: '',
                iconTheme: '',
                icon: '',
                submenu: []
            },
            // {
            //     path: '#',
            //     father: null,
            //     title: 'Ratios',
            //     admin: false,
            //     iconType: '',
            //     icon: '',
            //     iconTheme: '',
            //     submenu: []
            // }
        ]
    },
    // {
    //     path: '#',
    //     father: 'reports',
    //     title: 'PIN ConFinanzas',
    //     admin: false,
    //     iconType: 'custom',
    //     iconTheme: '',
    //     icon: 'pin-confinanzas-icon',
    //     submenu: [
    //         {
    //             path: '#',
    //             father: null,
    //             title: 'Velocímetros',
    //             admin: false,
    //             iconType: '',
    //             iconTheme: '',
    //             icon: '',
    //             submenu: []
    //         },
    //         {
    //             path: '#',
    //             father: null,
    //             title: 'Ratios',
    //             admin: false,
    //             iconType: '',
    //             icon: '',
    //             iconTheme: '',
    //             submenu: []
    //         }
    //     ]
    // },
    {
        path: '#',
        father: null,
        title: 'Remuneraciones Fintech',
        admin: false,
        iconType: 'custom',
        iconTheme: '',
        icon: 'pin-remuneraciones-icon',
        submenu: [
            {
                path: '/remunerations/panel-resumen',
                father: null,
                title: 'Panel Resumen',
                admin: false,
                iconType: '',
                iconTheme: '',
                icon: '',
                submenu: []
            }
        ]
    },
    {
        path: '/ondemand',
        father: null,
        title: 'OnDemand',
        admin: false,
        iconType: 'custom',
        iconTheme: '',
        icon: 'pin-ondemand-icon',
        submenu: []
    },
    {
        path: '#',
        father: 'settings',
        title: 'Configuración',
        admin: false,
        iconType: 'custom',
        iconTheme: '',
        icon: 'config-icon',
        submenu: [
            {
                path: '/settings/company-profile',
                father: null,
                title: 'Perfil de la Empresa',
                admin: false,
                iconType: '',
                icon: '',
                iconTheme: '',
                submenu: []
            },
            /*
            {
                path: '/settings/users',
                father: null,
                title: 'Usuarios',
                admin: true,
                iconType: '',
                iconTheme: '',
                icon: '',
                submenu: [],
            },
            */
            /*
            {
                path: '/settings/companies',
                father: null,
                title: 'Empresas',
                admin: true,
                iconType: '',
                iconTheme: '',
                icon: '',
                submenu: [],
            }
            */
        ]
    },
];